import { createSlice } from "@reduxjs/toolkit";

interface userInfo {
  address: string;
  company_position: string;
  country_id: string;
  created_at: string;
  date_of_birth: string;
  document_number: string;
  email: string;
  enabled: string;
  entity_id: string;
  gender_id: string;
  id: any;
  is_accepted_terms: any;
  is_active: any;
  is_admin: any;
  last_name: string;
  name: string;
  password: string;
  phone_number: string;
  profile_image: string;
  status_id: any;
  updated_at: any;
  user_pin: any;
}

interface userState {
  error: string | null | {};
  success: string | any;
  user: userInfo;
  documents: [];
}

export const initialState: userState = {
  error: "",
  success: "",
  user: {
    address: "",
    company_position: "",
    country_id: "",
    created_at: "",
    date_of_birth: "",
    document_number: "",
    email: "",
    enabled: "",
    entity_id: "",
    gender_id: "",
    id: undefined,
    is_accepted_terms: undefined,
    is_active: undefined,
    is_admin: undefined,
    last_name: "",
    name: "",
    password: "",
    phone_number: "",
    profile_image: "",
    status_id: undefined,
    updated_at: undefined,
    user_pin: undefined,
  },
  documents: [],
};

const ProfileSlice = createSlice({
  name: "Profile",
  initialState,
  reducers: {
    profileSuccess(state, action) {
      state.user = action.payload;
      state.success = "";
    },
    profileError(state, action) {
      state.error = action.payload;
    },
    editProfileChange(state) {
      state = { ...state };
    },
    resetProfileFlagChange(state) {
      state.success = "";
    },
    saveDocumentsEntity(state, action) {
      // console.log(action.payload);
      state.documents = action.payload;
    },
  },
});

export const {
  profileSuccess,
  profileError,
  editProfileChange,
  resetProfileFlagChange,
  saveDocumentsEntity,
} = ProfileSlice.actions;

export default ProfileSlice.reducer;
